import React from 'react'
import injectSheet from 'react-jss'
import styles from './menu.styles'
import classNames from 'classnames'

const Menu = ({ classes, className, children }) => (
  <ul className={classNames(classes.menu, className)}>{children}</ul>
)

export default injectSheet(styles)(Menu)
